import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { ChangableComponent } from '@app/models/changable.component';
import { AccountService, ContextService } from '@core/services';
import { EContentPanelRoute } from 'lingo2-models';
import { takeUntil } from 'rxjs/operators';

export type TDisplayMode = 'default' | 'middle' | 'short';

@Component({
  selector: 'app-free-date-banner',
  standalone: true,
  imports: [LocaleSharedModule, CommonModule, RouterModule],
  templateUrl: './free-date-banner.component.html',
  styleUrls: ['./free-date-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FreeDateBannerComponent extends ChangableComponent implements OnInit, OnDestroy {
  private contextService = inject(ContextService);

  @Input() displayMode: TDisplayMode = 'default';
  public isTeacher: boolean;

  public readonly routes = EContentPanelRoute;

  ngOnInit() {
    this.contextService.me$.pipe(takeUntil(this.destroyed$)).subscribe({
      next: (me) => {
        this.isTeacher = AccountService.isAsIfTeacher(me);
      },
      error: (error) => {
        this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
      },
    });
  }
}
